export const buildingItemCodes = ['CDR', 'CDS', 'RMA'];
export const dashboardItems: IDashboardItems[] = [
  {
    title: 'Controle de Acesso',
    icon: 'groups',
    originPath: '/controle-de-acesso',
    path: '/controle-de-acesso/novos-usuarios',
    isActive: false,
    code: 'GDU',
  },
  {
    title: 'Gestão de Revendas',
    iconReact: true,
    icon: 'storefront',
    originPath: '/gestao-de-revendas',
    path: '/gestao-de-revendas/novos-revendedores',
    isActive: false,
    code: 'GDR',
  },
  {
    title: 'Consulta de Pedidos',
    icon: 'box',
    originPath: '/pedidos',
    path: '/pedidos',
    isActive: false,
    code: 'CDP',
  },
  {
    title: 'Envio do DANFE e XML',
    icon: 'paper',
    originPath: '/envio-danfe-xml',
    path: '/envio-danfe-xml',
    isActive: false,
    code: 'EDX',
  },
  {
    title: 'Portal de Boletos',
    icon: 'billet',
    originPath: '/boletos',
    path: '/boletos',
    isActive: false,
    code: 'PDB',
  },
  {
    title: 'Consulta de Rastreamento',
    icon: 'truck',
    originPath: '/rastreamento',
    path: '/rastreamento',
    isActive: false,
    code: 'CDR',
  },
  {
    title: 'Consulta de Seriais',
    icon: 'search',
    originPath: '/serial',
    path: '/serial',
    isActive: false,
    code: 'CDS',
  },
  {
    title: 'RMA',
    icon: 'refresh',
    originPath: '/rma',
    path: '/rma',
    isActive: false,
    code: 'RMA',
  },
  {
    title: 'Consulta de Logs',
    icon: 'logs',
    originPath: '/logs',
    path: '/logs/consulta',
    isActive: false,
    code: 'CDL',
  },
  {
    title: 'Controle de Comissionamento',
    icon: 'money',
    originPath: '/comissionamento',
    path: '/comissionamento',
    isActive: false,
    code: 'CDC',
  },
  {
    title: 'Gestão de Equipe',
    icon: 'groups',
    originPath: '/controle-de-acessco',
    path: '/gestao-de-equipe/equipe',
    isActive: false,
    code: 'GDE',
  },
];

export interface IDashboardItems {
  title: string;
  icon: string;
  originPath: string;
  path: string;
  isActive: boolean;
  code: string;
  iconReact?: boolean;
}
